import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { STATE_STYLE, ApptBadge } from './util';

// Collapsed by default on phones so the current client stays the focus.
export const QueueList = ({ session, onGoto }) => {
  const [open, setOpen] = useState(false);
  return (
    <aside className="rounded-2xl border border-slate-200 bg-white p-3" data-testid="call-queue-list">
      <button type="button" onClick={() => setOpen((v) => !v)} data-testid="call-queue-toggle" className="flex w-full items-center justify-between px-1 py-1 text-left lg:pointer-events-none lg:pb-2 lg:pt-0">
        <span className="text-[11px] font-black uppercase tracking-wider text-slate-500">{session.label} · {session.remaining} to go</span>
        <span className="inline-flex items-center gap-1 text-xs font-bold text-slate-600 lg:hidden">{open ? 'Hide' : 'See queue'}<ChevronDown className={`h-4 w-4 transition-transform ${open ? 'rotate-180' : ''}`} /></span>
      </button>
      <ol className={`mt-1 max-h-[60vh] space-y-1 overflow-y-auto lg:block ${open ? 'block' : 'hidden'}`}>
        {session.items.map((it) => (
          <li key={it.index}>
            <button type="button" onClick={() => { onGoto(it.index); setOpen(false); }} data-testid={`call-queue-item-${it.index}`} className={`flex w-full items-center gap-2 rounded-xl px-2.5 py-2.5 text-left text-xs transition-colors ${it.index === session.cursor ? 'bg-indigo-50 ring-1 ring-indigo-300' : 'hover:bg-slate-50'}`}>
              <span className="w-5 shrink-0 text-right font-bold tabular-nums text-slate-400">{it.index + 1}</span>
              <span className="min-w-0 flex-1">
                <span className="block truncate font-bold text-slate-900">{it.name}</span>
                <span className="block truncate text-slate-500">{it.status_label}</span>
                {it.next_appointment_at && <ApptBadge at={it.next_appointment_at} />}
              </span>
              <span className={`shrink-0 rounded-full px-2 py-0.5 text-[10px] font-bold ${STATE_STYLE[it.state]}`}>{it.state === 'done' ? (session.outcomes[it.outcome] || 'Done') : it.state === 'skipped' ? 'Skipped' : 'To call'}</span>
            </button>
          </li>))}
      </ol>
    </aside>
  );
};
